import {
  convertConversation,
  convertRole,
  Member,
  UsersResponse,
} from '@nextforce/api'
import * as Response from './response'
import { ComposeGroup, ComposeMessageEvent, ComposeUser } from './types'

function convertComposeGroup(group: Response.Group): ComposeGroup {
  return {
    type: 'group',
    id: String(group.id),
    title: group.title,
  }
}

export function convertComposeUser(user: Response.User): ComposeUser {
  return {
    type: 'user',
    id: String(user.id),
    storeId: user.ref_store_id,
    firstName: user.first_name,
    lastName: user.last_name,
    roles: user.roles?.map(convertRole),
  }
}

export function convertManagersList(
  managers: UsersResponse.User[]
): ComposeUser[] {
  return managers.map(convertComposeUser)
}

export function convertComposeMessageEvent(
  composeMessageEvent: Response.ComposeMessageEvent
): ComposeMessageEvent | undefined {
  const newConversation = composeMessageEvent.conversation
  const addMessageEvents = composeMessageEvent.messages

  if (!addMessageEvents && !newConversation) {
    return
  }

  return {
    addMessageEvents: addMessageEvents,
    conversation: newConversation
      ? convertConversation(newConversation)
      : undefined,
  }
}

export function convertMemberToComposeUser(member: Member): ComposeUser {
  return {
    type: 'user',
    id: member.id,
    firstName: member.firstName,
    lastName: member.lastName,
    storeId: member.refStoreId,
    roles: member.roles,
    jobTitle: member.jobTitle,
  }
}
